import { buildSendTimeOptions } from '~/helpers/notificationPrefs';

const SEND_TIME_OPTIONS = buildSendTimeOptions(30);

type Props = {
  value: string;
  onChange: (next: string) => void;
  disabled?: boolean;
  'aria-label'?: string;
};

export const SendTimeSelect = ({
  value,
  onChange,
  disabled,
  ...rest
}: Props) => {
  return (
    <select
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
      className='rounded border border-outline-variant bg-white px-2 py-1 text-sm text-primary'
      {...rest}
    >
      {SEND_TIME_OPTIONS.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
};
